import React from 'react';

interface IntegrationUrlModalProps {
  isOpen: boolean;
  onClose: () => void;
  integrationUrl: string;
  onCopy: (url: string) => void;
  title?: string;
  description?: string;
}

const IntegrationUrlModal: React.FC<IntegrationUrlModalProps> = ({
  isOpen,
  onClose,
  integrationUrl,
  onCopy,
  title = "Integration Link",
  description = "Share this link with the user of ARiA to complete the integration:"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-2xl shadow-lg rounded-md bg-white">
        <div className="mt-3 text-left">
          <h3 className="text-lg font-medium text-gray-900 mb-6 text-left">{title}</h3>
          <div className="space-y-4 text-left">
            <p className="text-sm text-gray-600 text-left">
              {description}
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  value={integrationUrl}
                  readOnly
                  className="flex-1 bg-white border border-gray-300 rounded-md px-3 py-2 text-sm"
                />
                <button
                  onClick={() => onCopy(integrationUrl)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm"
                >
                  Copy
                </button>
              </div>
            </div>
            <div className="text-xs text-gray-500 text-left">
              <p>• This link will expire in 7 days for Xero integrations, 30 days for others</p>
              <p>• The user will be redirected to authorize the integration</p>
              <p>• Once authorized, the integration will be automatically completed</p>
            </div>
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationUrlModal;
